import CryptoJS from 'crypto-js'

var keyBase = 'yYsNdCn2oq6u1h/LuoAx08RebIh9lIfezVxsyl7C4Y8=' // 加密秘钥的基值
var ivBase = 'eoybIfcZolEackqr' // 加密所需iv基值

// 加密
const encrypt = word => {
  var keyHash = CryptoJS.MD5(keyBase)
  var key = CryptoJS.enc.Utf8.parse(keyHash)
  var iv = CryptoJS.enc.Utf8.parse(ivBase)
  var res = CryptoJS.AES.encrypt(word, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  })
  return res.toString()
}

const decrypt = function (data) {
  var keyHash = CryptoJS.MD5(keyBase)
  var key = CryptoJS.enc.Utf8.parse(keyHash)
  var iv = CryptoJS.enc.Utf8.parse(ivBase)
  var bytes = CryptoJS.AES.decrypt(data, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  return bytes.toString(CryptoJS.enc.Utf8);
}

export default {
  encrypt: encrypt,
  decrypt: decrypt
}
